import {
  InvoiceResponse,
  InvoiceTableData,
  InvoiceTableRow,
  Parameters,
  ReceiptResponse,
} from '@app/models/finances/FinancesResponse';
import { get, post } from './http.api';
import { idText } from 'typescript';

export const getInvoiceListTableData = async (parameters: Parameters): Promise<InvoiceTableData> => {
  try {
    const { data, status } = await get<any>('invoices', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const invoiceList = data?.invoices?.data ?? [];

    const Invoices: InvoiceTableRow[] = invoiceList.map((invoiceData: any) => ({
      id: invoiceData.id,
      invoice_number: invoiceData.invoice_number,
      partner_name: invoiceData.partner_name,
      department_name: invoiceData.department_name,
      referenceable_code: invoiceData.referenceable_code,
      referenceable_type_label: invoiceData.referenceable_type_label,
      status: invoiceData.status,
      total: invoiceData.total,
    }));

    return {
      data: Invoices,
      status: Array.isArray(data.status) ? data.status : [],
      filter_options:
        data?.filter_options && typeof data.filter_options === 'object' && !Array.isArray(data.filter_options)
          ? data.filter_options
          : {
              cashier_location_options: [],
              cashier_user_options: [],
              date_related_to_options: [],
              status_options: [],
              partner_type_options: [],
              referenceable_type_options: [],
              payment_method_options: [],
              department_options: [],
            },
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Invoices:', error);
    throw error;
  }
};

export const getAllInvoices = async (): Promise<InvoiceResponse> => {
  try {
    const { data, status } = await get<InvoiceResponse>(`invoices`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getInvoiceById = async (id: number): Promise<InvoiceResponse> => {
  try {
    const { data, status } = await get<InvoiceResponse>(`invoices/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const MakeInvoicePayment = async (invoiceId: number, method: string, amount: string) => {
  try {
    const payload = { method, amount };
    const response = await post<any>(`invoices/${invoiceId}/pay`, payload, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getReceiptListTableData = async (parameters: Parameters): Promise<InvoiceTableData> => {
  try {
    const { data, status } = await get<any>('receipts', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const receiptList = data?.receipts?.data ?? [];

    const Receipts: InvoiceTableRow[] = receiptList.map((receiptData: any) => ({
      id: receiptData.id,
      invoice_id: receiptData.invoice_id,
      receipt_code: receiptData.code,
      issued_by: receiptData.issued_by,
      amount: receiptData.amount,
      payment_method: receiptData.payment_method,
      payment_reference: receiptData.payment_reference,
      issued_at: receiptData.issued_at,
      invoice_number: receiptData.invoice_number,
      payment_type: receiptData.payment_type,
      receipt_number: receiptData.invoice_number,
      partner_name: receiptData.partner_name,
      cashier_location: receiptData.cashier_location,
      department_name: receiptData.department_name,
      referenceable_code: receiptData.referenceable_code,
      referenceable_type_label: receiptData.referenceable_type_label,
      invoice_status: receiptData.invoice_status,
    }));

    return {
      data: Receipts,
      status: Array.isArray(data.status) ? data.status : [],
      filter_options:
        data?.filter_options && typeof data.filter_options === 'object' && !Array.isArray(data.filter_options)
          ? data.filter_options
          : {
              cashier_location_options: [],
              cashier_options: [],
              status_options: [],
              partner_type_options: [],
              referenceable_type_options: [],
              payment_method_options: [],
              department_options: [],
            },
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Receipts:', error);
    throw error;
  }
};

export const getAllReceipts = async (): Promise<InvoiceResponse> => {
  try {
    const { data, status } = await get<InvoiceResponse>(`receipts`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getReceiptById = async (id: number): Promise<ReceiptResponse> => {
  try {
    const { data, status } = await get<ReceiptResponse>(`receipts/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};
